export enum AlertType {
  error = 'error',
  info = 'info',
  warning = 'warning',
}
